import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const InventoryAdjustment = {
	name: NAME,
	apiProvider,
	router,
};
